const baseURL = {
    URL: 'https://www.plannbuild.com/api',

}

export default baseURL;